import { Vue, Options } from 'vue-class-component';
import i18n from '@/core/translations/i18n';
@Options({
  name: 'HelpPopupButton',
})
export default class HelpPopupButton extends Vue {
  showHelpDialog = false;
  title = i18n.global.t('AppResource.Help');
  description = i18n.global.t('AppResourceEP.DisplayOfCallModeTypes');

  toggleHelpDialog() {
    this.showHelpDialog = !this.showHelpDialog;
  }
  get callModeHelpDescription() {
    return this.$t('AppResourceEP.CallModeHelpDescription').split('\n');
  }
  handleDropdownVisibleChange(visible: boolean) {
    this.showHelpDialog = visible;
  }
}
